"use client";
import * as React from "react";
const SvgMailRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.4.5H1.6C.72.5 0 1.23 0 2.13v9.75c0 .89.72 1.62 1.6 1.62h12.8c.88 0 1.6-.73 1.6-1.62V2.12C16 1.23 15.28.5 14.4.5m-.32 3.45L8.85 7.38a1.6 1.6 0 0 1-1.7 0L1.92 3.95a.7.7 0 0 1-.32-.58.68.68 0 0 1 1.04-.59L8 6.18l5.36-3.4a.68.68 0 0 1 1.04.59.7.7 0 0 1-.32.58" }));
export {
  SvgMailRound as default
};
